module.exports = __webpack_public_path__ + "friend10.png?6c31070a67ebbfba4834333e56c7c9e6";


//////////////////
// WEBPACK FOOTER
// ./static/assets/friend10.png
// module id = 483
// module chunks = 0